import { useEffect, useRef, useState } from 'react'
import { buscarCep } from '../../representadas/buscarCep'
import { camposDoCep, type FormularioRepresentada } from '../../representadas/formularioRepresentada'
import { ICMS_INTERNO_POR_UF } from '../../impostos/icmsInternoPorUf'
import { ESTILO_CAMPO, ESTILO_ROTULO, type PropsAba } from './estilosDaFornecedora'
import SecaoCadastro from './SecaoCadastro'
import { IconeCasa, IconeLupa } from './IconesDoCadastro'

const UFS = Object.keys(ICMS_INTERNO_POR_UF).sort()

// Pedido dela (28/09): a Localizacao ficou SO com o endereco -- os canais de
// contato foram para a Identificacao, para nao haver dois lugares.
export default function AbaLocalizacao({ form, setForm, editavel }: PropsAba) {
  const [buscando, setBuscando] = useState(false)
  const [aviso, setAviso] = useState<string | null>(null)
  // F2 (review final): mesmo raciocinio de AbaIdentificacao.tsx -- um CEP
  // atrasado nao pode preencher endereco num formulario ja gravado/descartado.
  const editavelRef = useRef(editavel)
  useEffect(() => { editavelRef.current = editavel }, [editavel])
  const mudar = (p: Partial<FormularioRepresentada>) => setForm((f) => ({ ...f, ...p }))

  // ViaCEP (spec 17/09): preenche so o que esta vazio; numero e complemento
  // sempre a mao -- CEP nao traz. Roda ao sair do campo E no botao Buscar CEP.
  async function buscarOCep() {
    if (!editavel || form.cep.trim() === '') { setAviso(null); return }
    setBuscando(true)
    setAviso(null)
    const encontrado = await buscarCep(form.cep)
    setBuscando(false)
    if (!editavelRef.current) return // aba nao esta mais em edicao: descarta o resultado atrasado
    if (!encontrado) { setAviso('Não consegui buscar esse CEP — preencha manualmente.'); return }
    setForm((f) => ({ ...f, ...camposDoCep(f, encontrado) }))
  }

  return (
    <SecaoCadastro icone={<IconeCasa />} titulo="Endereço da empresa">
      <div>
        <label htmlFor="rep-cep" className={ESTILO_ROTULO}>CEP</label>
        <div className="flex gap-2">
          <input id="rep-cep" inputMode="numeric" value={form.cep} onChange={(e) => mudar({ cep: e.target.value })}
            onBlur={() => void buscarOCep()} disabled={!editavel} className={`${ESTILO_CAMPO} min-w-0`} />
          {editavel && (
            <button type="button" onClick={() => void buscarOCep()} disabled={buscando}
              className="shrink-0 flex items-center gap-1 rounded-lg bg-teal-50 text-teal-800 px-3 text-sm font-medium">
              <IconeLupa tamanho={16} /> Buscar CEP
            </button>
          )}
        </div>
        {buscando && <p className="text-xs text-slate-500 mt-1">Buscando endereço…</p>}
        {aviso && <p className="text-xs text-amber-700 mt-1">{aviso}</p>}
      </div>
      <div className="grid grid-cols-3 gap-3">
        <div className="col-span-2">
          <label htmlFor="rep-end" className={ESTILO_ROTULO}>Endereço</label>
          <input id="rep-end" value={form.endereco} onChange={(e) => mudar({ endereco: e.target.value })}
            disabled={!editavel} className={ESTILO_CAMPO} />
        </div>
        <div>
          <label htmlFor="rep-numero" className={ESTILO_ROTULO}>Número</label>
          <input id="rep-numero" value={form.numero} onChange={(e) => mudar({ numero: e.target.value })}
            disabled={!editavel} className={ESTILO_CAMPO} />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label htmlFor="rep-complemento" className={ESTILO_ROTULO}>Complemento</label>
          <input id="rep-complemento" value={form.complemento} onChange={(e) => mudar({ complemento: e.target.value })}
            placeholder="Ex.: Sala 101" disabled={!editavel} className={ESTILO_CAMPO} />
        </div>
        <div>
          <label htmlFor="rep-bairro" className={ESTILO_ROTULO}>Bairro</label>
          <input id="rep-bairro" value={form.bairro} onChange={(e) => mudar({ bairro: e.target.value })}
            disabled={!editavel} className={ESTILO_CAMPO} />
        </div>
      </div>
      <div className="grid grid-cols-3 gap-3">
        <div className="col-span-2">
          <label htmlFor="rep-mun" className={ESTILO_ROTULO}>Cidade</label>
          <input id="rep-mun" value={form.municipio} onChange={(e) => mudar({ municipio: e.target.value })}
            disabled={!editavel} className={ESTILO_CAMPO} />
        </div>
        <div>
          <label htmlFor="rep-uf" className={ESTILO_ROTULO}>UF</label>
          {/* Lista (pedido dela, 28/09). UF antiga fora da lista continua
              aparecendo, para nao sumir em silencio ao abrir. */}
          <select id="rep-uf" value={form.uf} onChange={(e) => mudar({ uf: e.target.value })}
            disabled={!editavel} className={ESTILO_CAMPO}>
            <option value="">—</option>
            {form.uf !== '' && !UFS.includes(form.uf) && <option value={form.uf}>{form.uf}</option>}
            {UFS.map((uf) => <option key={uf} value={uf}>{uf}</option>)}
          </select>
        </div>
      </div>
    </SecaoCadastro>
  )
}
